import { createContext } from 'react';

import { HoneycombLegendProps } from '../slots/HoneycombLegend.js';
export const HoneycombLegendConfigContext = createContext<
  HoneycombLegendProps | undefined
>(undefined);
